import { Logs } from '../../db-entries/index.js';
export * as interaction from './interaction.js';
export * as token from './token.js';
export * as hook from './hook.js';
export * as action from './action.js';
export * as jwtCustomizer from './jwt-customizer.js';
export * as saml from './saml.js';
export * as trustedDevice from './trusted-device.js';
/** Fallback for empty or unrecognized log keys. */
export const LogKeyUnknown = 'Unknown';
/** `Logs.guard` without the trigger-kept `payload_*` lookup columns, for API responses. */
export const logResponseGuard = Logs.guard.omit({
    payloadUserId: true,
    payloadApplicationId: true,
    payloadHookId: true,
});
